<template>
  <div class="wrapper">
    <c-input
      ref="date"
      v-model="localValue"
      type="date"
      placeholder="00.00.0000"
      :label="field.name"
      icon="calendar"
      :selects="selects"
      :clearable="true"
      :editable="true"
      :icon-right="true"
      :required-mark="field.required"
      :required="error"
      :required-message="error"
      :default-year="2000"
    />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import { FIELD_TYPE_BIRTHDAY } from "@/domains/profile/constants/system-types";

export default {
  components: { CInput },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: "",
    };
  },
  computed: {
    selects() {
      const { fieldType } = this.field;
      return fieldType === FIELD_TYPE_BIRTHDAY;
    },
  },
  watch: {
    localValue(v) {
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      this.localValue = value.value || "";
      if (this.$refs.date) {
        this.$refs.date.setDateInputTypeDate(this.localValue);
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 6px;
}
</style>
